/*
 * air-airpro.js — native behaviour for the converted pulsio-eu Air PRO PDP.
 * Replaces the stripped Replo runtime for the interactions this page uses:
 *   1. Collapsibles / accordions (delivery, warranty, returns, specs, etc.)
 *   2. Carousels (reviews slider, attachment carousel) — transform based.
 *   3. Add-to-cart: [data-replo-add-product-variant-to-cart] submits its /cart/add form.
 *   4. Related/accessory product cards navigate to their product page (never the buy box).
 *   5. Tab toggles ([data-replo-tabs-trigger]) — pill styling + tabpanel switching.
 *   6. Background videos — hydrate empty <video> tags from data-rid → CDN map.
 *   7. Attachment explorer (s3): linked inner carousels + attachment video hydration.
 *   8. Buy box: heated attachment toggle, CTA availability, add-to-cart (main + optional accessory).
 *   9. Sleek-style scroll reveals (CSS transitions + IntersectionObserver), incl. the
 *      alchemy-fade fix so converted sections are not left invisible.
 * No dependencies; idempotent per element; safe to load once.
 */
(function () {
  if (window.__airProInit) return;
  window.__airProInit = true;

  var TRANSITION = 'transform 450ms cubic-bezier(0.22, 0.61, 0.36, 1)';
  var REVEAL_OPTS = { rootMargin: '0px 0px -8% 0px', threshold: 0.12 };
  /* Amplitude / depth comparison — reveal overlay before it fully enters view. */
  var REVEAL_EARLY_OPTS = { rootMargin: '0px 0px 25% 0px', threshold: 0.01 };
  /* Play as soon as any pixel of the observe target enters the viewport. */
  var VIDEO_IO_OPTS = { rootMargin: '0px', threshold: 0 };
  var VIDEO_PRELOAD_IO_OPTS = { rootMargin: '200px 0px 200px 0px', threshold: 0 };
  /* Inner video data-rid → visible feature shell (never a distant section / bottom anchor). */
  var VIDEO_OBSERVE_ROOT = {
    '01c3ead5-3e6b-4d0f-90f2-144f189d65ce': '29da58dc-c99f-4219-8de1-7de81c69902c',
    'f0db6c4f-110e-4895-87be-3d76d31f7c55': 'a6e3f897-2dd0-4f5e-86cc-3a370b3e57c3',
    '19cd9fa2-a780-4cd0-803b-89e7d9d22c9c': '000dd9f8-80a0-4930-8032-17d5406dff7b',
    '88b587ec-06b1-41a0-a19a-f4a82fd74d75': '000dd9f8-80a0-4930-8032-17d5406dff7b'
  };
  var ALCHEMY_IO_OPTS = { rootMargin: '0px 0px 20% 0px', threshold: 0.01 };
  var AMPLITUDE_ROOT_RIDS = {
    'a6e3f897-2dd0-4f5e-86cc-3a370b3e57c3': true,
    '29da58dc-c99f-4219-8de1-7de81c69902c': true
  };
  var VIDEO_AMPLITUDE_RIDS = {
    '01c3ead5-3e6b-4d0f-90f2-144f189d65ce': true,
    'f0db6c4f-110e-4895-87be-3d76d31f7c55': true
  };
  var STAGGER_MS = 80;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Self-hosted compressed videos (Shopify Files) */
  var REPRO_VIDEOS = {
    e3b23617: 'https://cdn.shopify.com/videos/c/vp/de102256923a4ca89612b138e7966e5f/de102256923a4ca89612b138e7966e5f.SD-480p-0.9Mbps-88074824.mp4',
    v8e770766: 'https://cdn.shopify.com/videos/c/vp/bb295111a71045cfb6bb430713340051/bb295111a71045cfb6bb430713340051.SD-480p-0.9Mbps-88074820.mp4',
    c7c2f97b: 'https://cdn.shopify.com/videos/c/vp/94ec31a0b32d440fa41a096a7aa3b349/94ec31a0b32d440fa41a096a7aa3b349.SD-480p-0.9Mbps-88074818.mp4',
    v7ef105c8: 'https://cdn.shopify.com/videos/c/vp/4ffabae1d6d343efb8aa963596b9974c/4ffabae1d6d343efb8aa963596b9974c.SD-480p-0.9Mbps-88074819.mp4',
    v12397b35: 'https://cdn.shopify.com/videos/c/vp/af1fe91b83cd4cccaaa7bc418bd85262/af1fe91b83cd4cccaaa7bc418bd85262.SD-480p-0.9Mbps-88074821.mp4',
    vc301e51c: 'https://cdn.shopify.com/videos/c/vp/82044a7fde784dfc813a501c39ee0ed6/82044a7fde784dfc813a501c39ee0ed6.SD-480p-0.9Mbps-88074822.mp4',
    v85db198b: 'https://cdn.shopify.com/videos/c/vp/d5cf69d1ed21457da56268e62e18285c/d5cf69d1ed21457da56268e62e18285c.SD-480p-0.9Mbps-88074825.mp4',
    v85db198b_hq: 'https://cdn.shopify.com/videos/c/vp/480250f6f5ca4463b61892dbab304c51/480250f6f5ca4463b61892dbab304c51.SD-480p-0.9Mbps-88222750.mp4',
    poster85db198b_hq: 'https://cdn.shopify.com/s/files/1/0771/1762/0499/files/poster-85db198b-hq.jpg?v=1783337549',
    v738afa65: 'https://cdn.shopify.com/videos/c/vp/a986acd088b440529c4e6b595d96f782/a986acd088b440529c4e6b595d96f782.SD-480p-0.9Mbps-88221445.mp4',
    v2522682c: 'https://cdn.shopify.com/videos/c/vp/20a04b3955b64224bc44588f4c8c9dd2/20a04b3955b64224bc44588f4c8c9dd2.SD-480p-0.9Mbps-88220290.mp4',
    poster2522682c: 'https://cdn.shopify.com/s/files/1/0771/1762/0499/files/poster-2522682c.jpg?v=1783335371',
    poster: 'https://cdn.shopify.com/s/files/1/0771/1762/0499/files/poster-c7c2f97b_b87ea778-2f59-46e8-b777-fcd36447bc4e.jpg?v=1783109495'
  };
  /* data-rid → mp4 (Replo runtime used to hydrate empty <video> tags) */
  var VIDEO_BY_RID = {
    '897336a5-3461-4d24-9ef6-2f3a3ae8d803': REPRO_VIDEOS.v85db198b_hq,
    'cc63d48c-11ab-4ebd-8d62-52ac4f99c2d2': REPRO_VIDEOS.e3b23617,
    'f36830a7-7359-4a6c-8f3d-b68a13cb0387': REPRO_VIDEOS.v738afa65,
    'f0db6c4f-110e-4895-87be-3d76d31f7c55': REPRO_VIDEOS.v2522682c,
    '01c3ead5-3e6b-4d0f-90f2-144f189d65ce': REPRO_VIDEOS.v7ef105c8,
    '19cd9fa2-a780-4cd0-803b-89e7d9d22c9c': REPRO_VIDEOS.vc301e51c,
    '88b587ec-06b1-41a0-a19a-f4a82fd74d75': REPRO_VIDEOS.v85db198b,
    'd26f8c3b-cb21-48bb-9591-02d78d4ccc1c': REPRO_VIDEOS.v12397b35
  };
  var POSTER_BY_RID = {
    '897336a5-3461-4d24-9ef6-2f3a3ae8d803': REPRO_VIDEOS.poster85db198b_hq,
    'f0db6c4f-110e-4895-87be-3d76d31f7c55': REPRO_VIDEOS.poster2522682c
  };
  /* Flat Metal, Fork, Round, Air Lock (+ Bullet uses c7c2f97b when present) */
  var ATTACHMENT_VIDEOS = [
    REPRO_VIDEOS.v12397b35,
    REPRO_VIDEOS.v7ef105c8,
    REPRO_VIDEOS.v8e770766,
    REPRO_VIDEOS.e3b23617,
    REPRO_VIDEOS.c7c2f97b
  ];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function each(list, fn) {
    Array.prototype.forEach.call(list || [], fn);
  }

  /* ---------------- Collapsibles / accordions ---------------- */
  // Resolve the collapsible panel for a trigger. Radix-style ids can contain ':'
  // and may collide across separately-rendered Replo sections, so we prefer a
  // wrapper-scoped lookup and fall back to the trigger's next sibling.
  function collapsiblePanel(trigger, wrap) {
    var id = trigger.getAttribute('aria-controls');
    if (id) {
      var scoped = wrap && wrap.querySelector('[id="' + (window.CSS && CSS.escape ? CSS.escape(id) : id.replace(/"/g, '\\"')) + '"]');
      if (scoped) return scoped;
      var byId = document.getElementById(id);
      if (byId) return byId;
    }
    // fallback: first element after the trigger that isn't another trigger
    var sib = trigger.nextElementSibling;
    while (sib && sib.getAttribute && sib.getAttribute('role') === 'button') sib = sib.nextElementSibling;
    return sib || null;
  }

  function setCollapsible(trigger, open) {
    var wrap = trigger.closest('[data-replo-collapsible]');
    var panel = collapsiblePanel(trigger, wrap);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (wrap) wrap.setAttribute('data-state', open ? 'open' : 'closed');
    if (panel) {
      if (open) {
        panel.removeAttribute('hidden');
        panel.style.removeProperty('display');
      } else {
        panel.setAttribute('hidden', '');
      }
      panel.setAttribute('data-state', open ? 'open' : 'closed');
      // drive Replo's slideDown/slideUp animation hook if present
      var animated = panel.classList && panel.classList.contains('replo-animated')
        ? panel
        : panel.querySelector && panel.querySelector('.replo-animated');
      if (animated) animated.setAttribute('data-state', open ? 'open' : 'closed');
    }
  }

  function collapsibleTrigger(node) {
    if (!node || !node.closest) return null;
    return node.closest('[data-replo-collapsible] [aria-controls][role="button"], [data-replo-collapsible] [aria-controls][aria-expanded]');
  }

  // Delegated handlers so binding never depends on node availability at init time
  // and survives Theme Editor re-renders.
  function initCollapsibles() {
    if (document.__airCollDelegated) return;
    document.__airCollDelegated = true;
    document.addEventListener('click', function (e) {
      var trigger = collapsibleTrigger(e.target);
      if (!trigger) return;
      e.preventDefault();
      setCollapsible(trigger, trigger.getAttribute('aria-expanded') !== 'true');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var trigger = collapsibleTrigger(e.target);
      if (!trigger) return;
      e.preventDefault();
      setCollapsible(trigger, trigger.getAttribute('aria-expanded') !== 'true');
    });
  }

  /* ---------------- Add to cart ---------------- */
  function initAddToCart(scope) {
    var btns = (scope || document).querySelectorAll(
      '[data-replo-add-product-variant-to-cart]'
    );
    each(btns, function (btn) {
      if (btn.__airAtc) return;
      btn.__airAtc = true;
      btn.style.cursor = 'pointer';
      btn.addEventListener('click', function (e) {
        if (btn.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          return;
        }
        var form =
          btn.closest('form[action="/cart/add"]') ||
          btn.closest('[data-replo-product-container], [id^="replo-section-"]')
            ?.querySelector('form[action="/cart/add"]');
        if (!form) return;
        var idInput = form.querySelector('[name="id"]');
        if (idInput && !idInput.value) return; // no valid variant; let default happen
        e.preventDefault();
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    });
  }

  /* ---------------- Carousels ---------------- */
  function currentX(track) {
    var m = /translate3d\(\s*(-?[\d.]+)px/.exec(track.style.transform || '');
    return m ? parseFloat(m[1]) : 0;
  }
  function initCarousel(root) {
    if (window.AirCarousel && window.AirCarousel.init) {
      return window.AirCarousel.init(root);
    }
  }

  /* ---------------- Attachment explorer (s3 linked inner carousels) ---------------- */
  function dedupeSlides(track) {
    var all = Array.prototype.slice.call(track.querySelectorAll('[data-replo-part="slide"]'));
    var seen = {};
    var out = [];
    all.forEach(function (slide) {
      var raw = slide.getAttribute('data-slide-source-index');
      if (raw === null || raw === '') return;
      if (seen[raw]) return;
      seen[raw] = true;
      out.push({ el: slide, sourceIndex: parseInt(raw, 10) });
    });
    out.sort(function (a, b) { return a.sourceIndex - b.sourceIndex; });
    return out;
  }

  function initTrackCarousel(viewport, opts) {
    if (!viewport || viewport.__airTrackCarousel) return viewport.__airTrackCarousel;
    var track = viewport.querySelector('[data-replo-part="slide-track"]');
    if (!track) return null;
    var slides = dedupeSlides(track);
    if (!slides.length) return null;
    var index = 0;
    var listeners = [];
    function base() { return slides[0].el.offsetLeft; }
    function maxScroll() { return Math.max(0, track.scrollWidth - viewport.clientWidth); }
    function targetX(i) {
      return Math.max(0, Math.min(slides[i].el.offsetLeft - base(), maxScroll()));
    }
    function nearestIndex(x) {
      var best = 0, bestD = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(targetX(i) - x);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }
    function notify() {
      var si = slides[index].sourceIndex;
      listeners.forEach(function (fn) { fn(si); });
      return si;
    }
    function go(i, animate) {
      index = Math.max(0, Math.min(i, slides.length - 1));
      var x = targetX(index);
      track.style.transition = animate === false ? 'none' : TRANSITION;
      track.style.transform = 'translate3d(' + -x + 'px, 0, 0)';
      return notify();
    }
    function goSource(sourceIndex, animate) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].sourceIndex === sourceIndex) return go(i, animate);
      }
      return null;
    }
    if (opts && opts.clickToGo) {
      viewport.addEventListener('click', function (e) {
        if (e.target.closest('[data-replo-part="nav-button"]')) return;
        var slide = e.target.closest('[data-replo-part="slide"]');
        if (!slide || !viewport.contains(slide)) return;
        var raw = slide.getAttribute('data-slide-source-index');
        if (raw === null || raw === '') return;
        e.preventDefault();
        goSource(parseInt(raw, 10), true);
      });
    }
    var raf;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { go(index, false); });
    });
    index = nearestIndex(-currentX(track));
    var ctrl = {
      viewport: viewport,
      track: track,
      go: go,
      goSource: goSource,
      getSourceIndex: function () { return slides[index].sourceIndex; },
      goNext: function (animate) { return go(index + 1, animate); },
      goPrev: function (animate) { return go(index - 1, animate); },
      onChange: function (fn) { listeners.push(fn); }
    };
    viewport.__airTrackCarousel = ctrl;
    notify();
    return ctrl;
  }

  /* Replo root ids use a trailing colon, e.g. replo-carousel:Rkmmr2: */
  function findCarouselViewport(scope, rootSuffix) {
    return scope.querySelector(
      '[data-replo-root-id^="replo-carousel:' + rootSuffix + '"][data-replo-part="slides"]'
    );
  }

  /* Wire arrow buttons / dots on the outer [data-replo-carousel] shell. */
  function wireTrackCarouselUI(ctrl) {
    if (!ctrl || !ctrl.viewport) return;
    var root = ctrl.viewport.closest('[data-replo-carousel]');
    if (!root || root.__airTrackUI) return;
    root.__airTrackUI = true;
    root.__airCarousel = true;
    var prevBtn = root.querySelector('[data-replo-part="nav-button"][data-direction="previous"]');
    var nextBtn = root.querySelector('[data-replo-part="nav-button"][data-direction="next"]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        ctrl.goPrev(true);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        ctrl.goNext(true);
      });
    }
    each(root.querySelectorAll('[aria-label^="Go to slide"]'), function (dot, di) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        ctrl.go(di, true);
      });
    });
  }

  /*
   * The explorer has two tab selectors that must both reflect the active
   * attachment: the desktop label strip (Rkmmr2, active class r-1qvjjdc) and
   * the mobile label strip (R56mr2, active class r-tujke5). Each active class
   * is a Replo "selected" style pre-applied only to the first slide, so we
   * simply move it to the slide matching the current source index.
   */
  var ATTACHMENT_TABS = [
    { suffix: 'Rkmmr2', activeClass: 'r-1qvjjdc' },
    { suffix: 'R56mr2', activeClass: 'r-tujke5' }
  ];

  function setAttachmentTabStyle(scope, sourceIndex) {
    ATTACHMENT_TABS.forEach(function (tab) {
      var tabVp = findCarouselViewport(scope, tab.suffix);
      if (!tabVp) return;
      each(tabVp.querySelectorAll('.' + tab.activeClass), function (el) {
        el.classList.remove(tab.activeClass);
      });
      var slide = tabVp.querySelector(
        '[data-replo-part="slide"][data-slide-source-index="' + sourceIndex + '"]'
      );
      if (!slide) return;
      var label = slide.querySelector('.alchemy-rte');
      if (label) label.classList.add(tab.activeClass);
    });
  }

  function setAttachmentVideo(scope, sourceIndex) {
    var url = ATTACHMENT_VIDEOS[sourceIndex];
    if (!url) return;
    var av = window.AirVideo || {};
    each(scope.querySelectorAll(
      '[data-rid="d26f8c3b-cb21-48bb-9591-02d78d4ccc1c"] video,' +
      '[data-rid="fb06afa7-967a-4ca6-aa1b-d8f999415357"] video'
    ), function (video) {
      if (av.wireVideo) {
        av.wireVideo(video, url, null);
        av.tryPlayVideo(video);
        return;
      }
      if (video.getAttribute('src') === url) return;
      video.setAttribute('src', url);
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.muted = true;
      try {
        video.load();
        video.play().catch(function () {});
      } catch (err) {}
    });
  }

  function linkTrackCarousels(ctrls, onSourceIndex) {
    var syncing = false;
    function sync(sourceIndex, origin) {
      if (syncing) return;
      syncing = true;
      ctrls.forEach(function (ctrl) {
        if (ctrl && ctrl !== origin) ctrl.goSource(sourceIndex, true);
      });
      if (onSourceIndex) onSourceIndex(sourceIndex);
      syncing = false;
    }
    ctrls.forEach(function (ctrl) {
      if (!ctrl) return;
      ctrl.onChange(function (sourceIndex) { sync(sourceIndex, ctrl); });
    });
  }

  function initAttachmentExplorer() {
    var tabLabel = document.querySelector('[data-rid="c8c9abe3-ab49-482f-883a-1085dfc1c630"]');
    if (!tabLabel || tabLabel.__airAttachmentInit) return;
    var scope = tabLabel.closest('[id^="replo-section-"]');
    if (!scope) return;
    tabLabel.__airAttachmentInit = true;

    var tabCar = initTrackCarousel(findCarouselViewport(scope, 'Rkmmr2'), { clickToGo: true });
    if (!tabCar) return;
    var ctrls = [
      tabCar,
      initTrackCarousel(findCarouselViewport(scope, 'R56mr2'), { clickToGo: true }),
      initTrackCarousel(findCarouselViewport(scope, 'R1lkj2'), { clickToGo: true }),
      initTrackCarousel(findCarouselViewport(scope, 'Remr2')),
      initTrackCarousel(findCarouselViewport(scope, 'R1emr2'))
    ].filter(Boolean);

    ctrls.forEach(wireTrackCarouselUI);

    linkTrackCarousels(ctrls, function (sourceIndex) {
      setAttachmentTabStyle(scope, sourceIndex);
      setAttachmentVideo(scope, sourceIndex);
    });
    setAttachmentTabStyle(scope, tabCar.getSourceIndex());
    setAttachmentVideo(scope, tabCar.getSourceIndex());
  }

  /* ---------------- Product-card nav (never the buy box) ---------------- */
  function initProductNav(scope) {
    var cards = (scope || document).querySelectorAll('[data-replo-product-handle]');
    each(cards, function (card) {
      if (card.__airNav) return;
      // never hijack a card that contains an add-to-cart form (the buy box)
      if (card.querySelector('form[action="/cart/add"], [data-replo-add-product-variant-to-cart]')) return;
      var handle = (card.getAttribute('data-replo-product-handle') || '').trim();
      if (!handle || handle === 'empty-product' || handle.indexOf('{{') !== -1) return;
      card.__airNav = true;
      card.style.cursor = 'pointer';
      card.addEventListener('click', function (e) {
        if (e.target.closest('a[href], button, form, input, [data-replo-add-product-variant-to-cart]')) return;
        window.location.href = '/products/' + handle;
      });
    });
  }

  /* ---------------- Scroll reveals + alchemy fix ---------------- */
  function hasAlchemyPaused(el) {
    var cs = getComputedStyle(el);
    return cs.animationName && cs.animationName.indexOf('alchemy') !== -1 && cs.animationPlayState === 'paused';
  }
  function hasBackgroundImage(el) {
    if ((el.style.backgroundImage || '').indexOf('url') !== -1) return true;
    var cs = getComputedStyle(el);
    return cs.backgroundImage && cs.backgroundImage !== 'none';
  }
  function isInView(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vw = window.innerWidth || document.documentElement.clientWidth;
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
  }
  function videoVisible(video) {
    if (!video) return false;
    var r = video.getBoundingClientRect();
    return r.width > 40 && r.height > 40 && r.bottom > 0 && r.top < (window.innerHeight || 0);
  }
  function isAmplitudeBlock(el) {
    var n = el;
    while (n && n.getAttribute) {
      var rid = n.getAttribute('data-rid');
      if (rid && AMPLITUDE_ROOT_RIDS[rid]) return true;
      n = n.parentElement;
    }
    return false;
  }
  function videoPlayTarget(video) {
    var node = video.closest('[data-rid]');
    if (!node) return video;
    var rid = node.getAttribute('data-rid') || '';
    var outerRid = VIDEO_OBSERVE_ROOT[rid];
    if (outerRid) {
      var outer = document.querySelector('[data-rid="' + outerRid + '"]');
      if (outer) return outer;
    }
    return node;
  }
  function wirePreloadObserver(video, playTarget, src) {
    if (!src || video.getAttribute('src') || !('IntersectionObserver' in window)) return;
    var preloadIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        if (!video.getAttribute('src')) {
          video.setAttribute('src', src);
          try { video.load(); } catch (err) {}
        }
        preloadIo.disconnect();
      });
    }, VIDEO_PRELOAD_IO_OPTS);
    preloadIo.observe(playTarget);
  }
  function revealEl(el) {
    if (el.__airRevealed) return;
    el.__airRevealed = true;
    el.classList.remove('air-reveal-pending');
    el.classList.add('air-reveal-visible');
  }
  function tagReveal(el, variant, delayMs) {
    if (el.__airRevealTagged) return null;
    el.__airRevealTagged = true;
    el.setAttribute('data-air-reveal', variant || 'fade-up');
    if (delayMs) el.style.setProperty('--air-reveal-delay', delayMs + 'ms');
    el.classList.add('air-reveal-pending', 'air-reveal--' + (variant || 'fade-up'));
    if (reducedMotion || isInView(el)) { revealEl(el); return null; }
    return el;
  }
  function initAirMotion() {
    var toObserve = [];
    var alchemyBg = [];
    function observe(el) { if (el && !el.__airRevealed) toObserve.push(el); }

    each(document.querySelectorAll('[id^="replo-section-"]'), function (section) {
      each(section.querySelectorAll('[data-replo-carousel]'), function (carousel) {
        if (hasAlchemyPaused(carousel) && hasBackgroundImage(carousel)) { alchemyBg.push(carousel); return; }
        observe(tagReveal(carousel, 'fade-up', 0));
      });
    });

    // Replo alchemy-fade blocks -> Sleek-style CSS reveal (skip bg-image heroes)
    var nodes = document.querySelectorAll('[data-rid]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.__airRevealTagged || node.closest('[data-replo-carousel]')) continue;
      if (!hasAlchemyPaused(node)) continue;
      if (hasBackgroundImage(node)) { alchemyBg.push(node); continue; }
      node.classList.add('air-reveal--alchemy-override');
      observe(tagReveal(node, 'fade-up', 0));
    }

    function playAlchemy(el) { el.style.animationPlayState = 'running'; }
    if (alchemyBg.length) {
      if (!('IntersectionObserver' in window) || reducedMotion) {
        alchemyBg.forEach(playAlchemy);
      } else {
        var alchemyIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { playAlchemy(e.target); alchemyIo.unobserve(e.target); }
          });
        }, ALCHEMY_IO_OPTS);
        alchemyBg.forEach(function (el) { if (isInView(el)) playAlchemy(el); else alchemyIo.observe(el); });
      }
    }

    if (!toObserve.length) return;
    if (reducedMotion || !('IntersectionObserver' in window)) { toObserve.forEach(revealEl); return; }
    var early = [];
    var normal = [];
    toObserve.forEach(function (el) {
      if (isAmplitudeBlock(el)) early.push(el);
      else normal.push(el);
    });
    function bindRevealIo(list, opts) {
      if (!list.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { revealEl(e.target); io.unobserve(e.target); }
        });
      }, opts);
      list.forEach(function (el) { if (isInView(el)) revealEl(el); else io.observe(el); });
    }
    bindRevealIo(normal, REVEAL_OPTS);
    bindRevealIo(early, REVEAL_EARLY_OPTS);
  }

  /* ---------------- Tabs (segmented toggles + tabpanels) ---------------- */
  function tabInner(trigger) {
    return trigger.querySelector(':scope > div') || trigger.firstElementChild;
  }

  /* Per-tablist pill classes — do not infer from DOM (multiple tablists share the page). */
  var TAB_CLASS_PRESETS = [
    {
      match: function (tablist) {
        return tablist.closest('[data-rid="36a00545-f23f-425b-9ccc-2bc6fb6be758"]') ||
          tablist.closest('.r-1c1rttn');
      },
      active: 'r-z3lb3d r-1vhj4t8',
      inactive: 'r-1w6bxte'
    },
    {
      match: function (tablist) {
        return tablist.closest('[data-rid="0ab3bc9f-2e29-4395-9cf6-3784ca3052d3"]') ||
          tablist.closest('.r-k9ht53');
      },
      active: 'r-14axnt6 r-wo5ozz',
      inactive: 'r-1j2hn9a'
    },
    {
      match: function (tablist) {
        return tablist.closest('[data-rid="71bd4ae5-3e2c-4bb9-b694-b1152a6a1a15"]') ||
          tablist.closest('.r-9xrkbj');
      },
      active: 'r-uf23ks r-1ex2tsu',
      inactive: 'r-ijflp2'
    }
  ];

  function neutralizeTabInnerFocus(inner) {
    if (!inner) return;
    inner.setAttribute('tabindex', '-1');
  }

  function tabClassMap(tablist, triggers) {
    for (var i = 0; i < TAB_CLASS_PRESETS.length; i++) {
      if (TAB_CLASS_PRESETS[i].match(tablist)) return TAB_CLASS_PRESETS[i];
    }
    var active = null;
    var inactive = null;
    each(triggers, function (t) {
      if (t.getAttribute('data-state') === 'active' || t.getAttribute('aria-selected') === 'true') active = t;
      else if (!inactive) inactive = t;
    });
    if (!active) active = triggers[0];
    if (!inactive) inactive = triggers[1];
    var activeInner = tabInner(active);
    var inactiveInner = tabInner(inactive);
    if (!activeInner || !inactiveInner) return null;
    return {
      active: activeInner.className,
      inactive: inactiveInner.className
    };
  }

  function showTabPanel(trigger, on) {
    var panelId = trigger.getAttribute('aria-controls');
    if (!panelId) return;
    var panel = document.getElementById(panelId);
    if (!panel) return;
    panel.setAttribute('data-state', on ? 'active' : 'inactive');
    panel.style.display = on ? 'contents' : 'none';
    panel.hidden = !on;
    syncPanelVideos(panel, on);
  }

  function syncPanelVideos(panel, on) {
    if (!panel) return;
    each(panel.querySelectorAll('video'), function (video) {
      if (on) {
        if (video.__airVideoInit) video.__airVideoInit();
        else tryPlayVideo(video);
      } else {
        video.pause();
      }
    });
  }

  function tryPlayVideo(video) {
    if (window.AirVideo && window.AirVideo.tryPlayVideo) {
      window.AirVideo.tryPlayVideo(video);
      return;
    }
    if (!video || !video.getAttribute('src')) return;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.playsInline = true;
    video.muted = true;
    var playPromise = video.play && video.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
  }

  function wireVideo(video, src, poster) {
    if (!video) return;
    if (video.__airVideoWired) {
      if (src && !video.getAttribute('src')) {
        video.setAttribute('src', src);
        try { video.load(); } catch (err) {}
      }
      if (poster && !video.getAttribute('poster')) video.setAttribute('poster', poster);
      return;
    }
    video.__airVideoWired = true;
    if (src && !video.getAttribute('src')) {
      video.setAttribute('src', src);
      try { video.load(); } catch (err) {}
    }
    if (poster && !video.getAttribute('poster')) video.setAttribute('poster', poster);
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.playsInline = true;
    video.muted = true;
    video.defaultMuted = true;
    var container = video.closest('[data-rid]');
    var rid = (container || {}).getAttribute('data-rid') || '';
    if (!video.hasAttribute('loop') && container) {
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
    }
    if (rid.indexOf('f0db6c4f') === 0 || rid.indexOf('01c3ead5') === 0) {
      video.addEventListener('playing', function () {
        var wrap = video.parentElement;
        var still = wrap && wrap.querySelector('.r-1en6tul, .r-39d0wc');
        if (still) still.style.display = 'none';
      });
    }
    var playTarget = videoPlayTarget(video);
    var kickPlay = function () {
      if (videoVisible(video) || isInView(playTarget)) tryPlayVideo(video);
    };
    video.addEventListener('loadeddata', kickPlay);
    video.addEventListener('canplay', kickPlay);
    video.__airVideoInit = function () { tryPlayVideo(video); };
    wirePreloadObserver(video, playTarget, src);
    if (!('IntersectionObserver' in window) || reducedMotion) {
      tryPlayVideo(video);
      return;
    }
    if (isInView(playTarget) || videoVisible(video)) tryPlayVideo(video);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) tryPlayVideo(video);
        else if (!videoVisible(video)) video.pause();
      });
    }, VIDEO_IO_OPTS);
    io.observe(playTarget);
  }

  function initBackgroundVideos(scope) {
    var root = scope || document;
    each(root.querySelectorAll('[data-rid]'), function (node) {
      var rid = node.getAttribute('data-rid');
      var src = VIDEO_BY_RID[rid];
      var poster = POSTER_BY_RID[rid];
      if (!src && !poster) return;
      each(node.querySelectorAll('video'), function (video) {
        if (video.closest('[data-rid]') !== node) return;
        wireVideo(video, src, poster);
      });
    });
    each(Object.keys(VIDEO_BY_RID), function (rid) {
      var node = root.querySelector('[data-rid="' + rid + '"]');
      if (!node) return;
      var video = node.querySelector('video');
      if (!video || video.__airVideoWired) return;
      wireVideo(video, VIDEO_BY_RID[rid], POSTER_BY_RID[rid]);
    });
    each(root.querySelectorAll('[data-rid] video[src]'), function (video) {
      if (!video.__airVideoWired) wireVideo(video, null, null);
    });
  }

  function activateTab(trigger) {
    var tablist = trigger.closest('[role="tablist"]');
    if (!tablist) return;
    var triggers = Array.prototype.slice.call(tablist.querySelectorAll('[data-replo-tabs-trigger]'));
    if (triggers.length < 2) return;
    var classes = tabClassMap(tablist, triggers);
    each(triggers, function (t) {
      var on = t === trigger;
      t.setAttribute('data-state', on ? 'active' : 'inactive');
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      var inner = tabInner(t);
      if (inner && classes) {
        inner.className = on ? classes.active : classes.inactive;
        neutralizeTabInnerFocus(inner);
      }
      showTabPanel(t, on);
    });
    if (document.activeElement && document.activeElement.closest('[data-replo-tabs-trigger]')) {
      document.activeElement.blur();
    }
  }

  function syncTabsOnLoad(scope) {
    var seen = {};
    each((scope || document).querySelectorAll('[role="tablist"]'), function (tablist) {
      if (seen[tablist]) return;
      seen[tablist] = true;
      var triggers = Array.prototype.slice.call(tablist.querySelectorAll('[data-replo-tabs-trigger]'));
      if (triggers.length < 2) return;
      each(triggers, function (t) {
        neutralizeTabInnerFocus(tabInner(t));
      });
      var active = triggers.filter(function (t) {
        return t.getAttribute('data-state') === 'active' || t.getAttribute('aria-selected') === 'true';
      })[0] || triggers[0];
      activateTab(active);
    });
  }

  function initTabs() {
    if (document.__airTabsDelegated) return;
    document.__airTabsDelegated = true;
    document.addEventListener(
      'mousedown',
      function (e) {
        if (e.target.closest('[data-replo-tabs-trigger] > div')) e.preventDefault();
      },
      true
    );
    document.addEventListener(
      'focusin',
      function (e) {
        var inner = e.target.closest('[data-replo-tabs-trigger] > div');
        if (!inner) return;
        inner.blur();
      },
      true
    );
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-replo-tabs-trigger]');
      if (!trigger) return;
      e.preventDefault();
      activateTab(trigger);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var trigger = e.target.closest('[data-replo-tabs-trigger]');
      if (!trigger) return;
      e.preventDefault();
      activateTab(trigger);
    });
  }

  /* ---------------- Buy box (main product + heated attachment upsell) ---------------- */
  function readBuyBoxData() {
    var el = document.getElementById('air-airpro-buybox-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function openCartOrRedirect() {
    var drawer = document.querySelector('cart-drawer, #CartDrawer, .js-drawer--cart, #cart-notification');
    if (drawer) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (typeof drawer.open === 'function') {
        try { drawer.open(); return; } catch (err) {}
      }
      if (typeof drawer.show === 'function') {
        try { drawer.show(); return; } catch (err) {}
      }
      var opener = document.querySelector('[href="/cart"], [data-cart-toggle], .cart-link');
      if (opener) { opener.click(); return; }
    }
    window.location.href = (window.Shopify && window.routes && window.routes.cart_url) || '/cart';
  }

  var ACCESSORY_CARD_RID = 'e7b6d78e-e192-462a-8f2c-c57ae647279d';
  var ACCESSORY_STYLE_ID = 'air-heated-attachment-card-styles';

  /* Replo inline CSS beats normal overrides; inject :not(# )×3 rules once (same trick as Replo). */
  function injectAccessoryCardStyles(card) {
    if (!card || document.getElementById(ACCESSORY_STYLE_ID)) return;
    var sel =
      ':not(#\\20):not(#\\20):not(#\\20)[data-rid="' + ACCESSORY_CARD_RID + '"].r-1ccpiig';
    var style = document.createElement('style');
    style.id = ACCESSORY_STYLE_ID;
    style.textContent =
      sel +
      '{transition:border-color 150ms cubic-bezier(0.4,0,0.2,1),border-width 150ms cubic-bezier(0.4,0,0.2,1)!important}' +
      sel +
      ':focus,' +
      sel +
      ':focus-visible{outline:none!important;box-shadow:none!important;-webkit-tap-highlight-color:transparent}' +
      sel +
      '[data-air-accessory-selected="true"]{border-top:2px solid #00B7FC!important;border-right:2px solid #00B7FC!important;border-bottom:2px solid #00B7FC!important;border-left:2px solid #00B7FC!important;outline:none!important;box-shadow:none!important}';
    document.head.appendChild(style);
  }

  function initBuyBox() {
    if (document.__airBuyBoxInit) return;
    var data = readBuyBoxData();
    var accessoryCardEarly =
      document.querySelector('[data-rid="' + ACCESSORY_CARD_RID + '"]') ||
      document.querySelector('.r-m6s5k0 .r-1ccpiig');
    if (!data || (data.attachmentId && !accessoryCardEarly)) {
      document.__airBuyBoxAttempts = (document.__airBuyBoxAttempts || 0) + 1;
      if (document.__airBuyBoxAttempts < 24) requestAnimationFrame(initBuyBox);
      return;
    }
    document.__airBuyBoxInit = true;

    var mainContainer = document.querySelector('[data-rid="e357b1dc-8928-4dbc-94ea-61b61c8b09fe"]');
    var mainForm = mainContainer && mainContainer.querySelector('form[action="/cart/add"]');
    var availWrap =
      document.querySelector('[data-rid="94e7cfeb-c5d6-448f-b533-2839d47897a8"]') ||
      document.querySelector('.r-fgblly');
    var accessoryCard =
      document.querySelector('[data-rid="' + ACCESSORY_CARD_RID + '"]') ||
      document.querySelector('.r-m6s5k0 .r-1ccpiig');
    injectAccessoryCardStyles(accessoryCard);
    var buyBtn = availWrap && availWrap.querySelector('.r-1z003ea');
    var priceEl =
      (availWrap && (availWrap.querySelector('.r-o5opai span') || availWrap.querySelector('.r-o5opai'))) ||
      null;
    var attachmentSelected = false;

    function syncSoldOut() {
      if (!availWrap) return;
      /* CTA sold-out state follows the main product only — never the accessory. */
      availWrap.classList.toggle('r-1ua20d4', !data.mainAvailable);
      if (window.AirSoldOut) window.AirSoldOut.setMainAvailable(data.mainAvailable);
    }

    function syncPrice() {
      if (!priceEl) return;
      var text =
        attachmentSelected && data.combinedPriceFormatted
          ? data.combinedPriceFormatted
          : data.mainPriceFormatted;
      if (text) priceEl.textContent = text;
    }

    function clearAccessoryInlineStyles(el) {
      [
        'border',
        'border-top',
        'border-right',
        'border-bottom',
        'border-left',
        'border-color',
        'border-width',
        'outline',
        'box-shadow'
      ].forEach(function (prop) {
        el.style.removeProperty(prop);
      });
    }

    function setAccessorySelected(on) {
      attachmentSelected = !!on;
      if (accessoryCard) {
        accessoryCard.setAttribute('data-air-accessory-selected', on ? 'true' : 'false');
        accessoryCard.setAttribute('aria-pressed', on ? 'true' : 'false');
        clearAccessoryInlineStyles(accessoryCard);
      }
      syncPrice();
      syncSoldOut();
    }

    function addToCart(e) {
      e.preventDefault();
      if (!data.mainAvailable || !data.mainId) return;
      var items = [{ id: String(data.mainId), quantity: 1 }];
      if (attachmentSelected && data.attachmentId) {
        items.push({ id: String(data.attachmentId), quantity: 1 });
      }
      if (buyBtn) buyBtn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (d) {
            return { ok: r.ok, d: d };
          });
        })
        .then(function (res) {
          if (buyBtn) buyBtn.removeAttribute('aria-busy');
          if (!res.ok) {
            if (mainForm && typeof mainForm.requestSubmit === 'function') mainForm.requestSubmit();
            else if (mainForm) mainForm.submit();
            return;
          }
          openCartOrRedirect();
        })
        .catch(function () {
          if (buyBtn) buyBtn.removeAttribute('aria-busy');
          if (mainForm && typeof mainForm.requestSubmit === 'function') mainForm.requestSubmit();
          else if (mainForm) mainForm.submit();
        });
    }

    syncSoldOut();
    syncPrice();

    if (accessoryCard && data.attachmentId) {
      accessoryCard.style.cursor = 'pointer';
      if (!accessoryCard.hasAttribute('tabindex')) accessoryCard.setAttribute('tabindex', '0');
      accessoryCard.setAttribute('aria-pressed', 'false');
      var toggleAccessory = function (e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        setAccessorySelected(!attachmentSelected);
        if (accessoryCard.blur) accessoryCard.blur();
      };
      accessoryCard.addEventListener('click', toggleAccessory);
      accessoryCard.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') toggleAccessory(e);
      });
    }

    if (buyBtn) {
      buyBtn.style.cursor = 'pointer';
      buyBtn.addEventListener('click', addToCart);
    }
  }

  function runInit(name, fn) {
    try {
      fn();
    } catch (err) {
      if (typeof console !== 'undefined' && console.error) {
        console.error('[air-airpro] ' + name + ' failed', err);
      }
    }
  }

  ready(function () {
    initBuyBox();
    runInit('initBackgroundVideos', function () {
      if (window.AirVideo && window.AirVideo.initBackgroundVideos) {
        window.AirVideo.initBackgroundVideos(document);
      } else {
        initBackgroundVideos(document);
      }
    });
    runInit('initTabs', initTabs);
    runInit('syncTabsOnLoad', function () { syncTabsOnLoad(document); });
    runInit('initAttachmentExplorer', initAttachmentExplorer);
    runInit('initCarousel', function () {
      each(document.querySelectorAll('[data-replo-carousel]'), initCarousel);
    });
    runInit('initCollapsibles', initCollapsibles);
    runInit('initAddToCart', function () { initAddToCart(document); });
    runInit('initProductNav', function () { initProductNav(document); });
    runInit('initAirMotion', initAirMotion);
  });
})();
